export const galleryCategories = ['Vitrin', 'WC', 'Prizler', 'Camlar', 'Kasa Defteri', 'Alışveriş Fişleri', 'Depo', 'Diğer'];
